<ion-content>
  <section height-100 flex flex-column class="ion-align-items-center ion-justify-content-start orange-bg">
    <section>
      <h1 class="ion-text-center" regular>
        Erro 410
      </h1>
      <h2 class="ion-text-center" margin regular>
        Essa página não está disponível.
      </h2>
    </section>
    <ion-button color="buttonPrimary" (click)="goHome()" margin>
      Página inicial
    </ion-button>
  </section>
</ion-content>
